import React from 'react';
import { Link } from 'react-router-dom';

const ServiceSection = () => {
  const features = [
    {
      id: 1,
      text: "Supportive Government Policies"
    },
    {
      id: 2,
      text: "Strategic Location & Superior Connectivity"
    },
    {
      id: 3,
      text: "Highly Dedicated and Dynamic Workforce"
    },
    {
      id: 4,
      text: "Innovation & Education Ecosystem"
    },
    {
      id: 5,
      text: "Abundant Natural Resources"
    }
  ];

  return (
    <div className="service_section">
      {/* About with Rating Shortcode */}
      <div className="fn_cs_about_with_rating">
        <div className="container">
          <div className="awr_inner">
            <div className="left_part">
              <div className="title_holder">
                <h3>Vidarbha — Where Opportunity Begins</h3>
                <p>Vidarbha is entering a new era of opportunity, driven by innovation, investment, and collaborative development. Its rich resources, skilled talent pool, and evolving ecosystem make it a promising landscape for industries aiming to lead the next wave of India’s growth. Here, investors find not just economic potential, but the chance to shape a region transforming into a hub of enterprise and prosperity.</p>
                <p>With large-scale industrial projects underway and increasing capital inflow in sectors such as mining, steel, agribusiness and logistics, Vidarbha offers a strategically valuable environment for expansion. The region’s connectivity through MIHAN, national highways, and rail networks strengthens supply chains and reduces logistics costs.</p>
              </div>
              <div >

                <Link
                  to="/login"
                  className="rqa-btn"
                  style={{ backgroundColor: "#6a05a8", color: "#fff" , padding: "12px 20px", borderRadius: "5px", textDecoration: "none"}}
                >
                  <span className="inner" style={{fontSize:"25px"}}>
                    Join Us <i className="fa fa-caret"></i>
                  </span>
                </Link>

              </div>
            </div>
            <div className="right_part">
              <div className="r_inner">
                <div className="top_section">
                  <div style={{ width: "100%", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
                    <iframe 
                      width="100%" 
                      height="350"
                      src="https://www.youtube.com/embed/_-c7dEdri3s?si=V26trsfQw4fHVap2"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ display: "block" }}
                    ></iframe>
                  </div>
                  {/* <div className="rating_holder">
                    <div className="r_header"></div>
                    <div className="r_footer"></div>
                    <a href="#"></a>
                    <img className="fn__svg" src="svg/stars.svg" alt="svg" />
                    <h3 className="rating_number">10</h3>
                    <h3 className="rating_text"></h3>
                  </div> */}
                </div>
                <div className="bottom_section">
                  <div className="list">
                    <ul>
                      {features.map(feature => (
                        <li key={feature.id}>
                          <div className="item">
                            <span className="icon">
                              <img className="fn__svg" src="svg/checked.svg" alt="svg" />
                            </span>
                            <p>{feature.text}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /About with Rating Shortcode */}
    </div>
  );
};

export default ServiceSection;